import { enGB, nb, enIE } from 'date-fns/locale'

import { AppLocale, CountryCode, LeaseplanCode } from '../types/i18n'

export const defaultLocale: AppLocale = 'en-gb'
export const defaultCountry: CountryCode = 'gb'
export const defaultLPCode: LeaseplanCode = `LPGB`

export const enNO = {
  ...nb,
  code: 'en-no',
  localize: enGB.localize,
  formatLong: enGB.formatLong,
  match: enGB.match,
}

// We include all locale languages apart native even though we don't have dateFns
// english locales for some of them. Better to be flexible for the case dateFns
// adds them or we write our own versions.
export const supportedDateFnsLocales: Record<AppLocale, Locale> = {
  'en-ie': enIE,
  'nb-no': nb,
  'en-no': enNO,
  [defaultLocale]: enGB,
}

export const supportedLocales = Object.keys(
  supportedDateFnsLocales,
) as ReadonlyArray<keyof typeof supportedDateFnsLocales>

// The ISO country codes we actually support, derived from the supported locales
// (e.g. 'en-ie' -> 'ie'). Used to validate IP geo-lookups against known countries.
export const supportedCountryCodes = Array.from(
  new Set(
    supportedLocales.map((locale) => locale.split('-')[1] as CountryCode),
  ),
) as ReadonlyArray<CountryCode>

export function isSupportedLocale(locale: string | null): locale is AppLocale {
  return !!locale && !!supportedDateFnsLocales[locale as AppLocale]
}

export const isSupportedCountryCode = (
  countryCode: string | null | undefined,
): countryCode is string =>
  !!countryCode &&
  supportedCountryCodes.includes(countryCode.toLowerCase() as CountryCode)
